var tooltipTimeout;


export const showTooltipNow = data => ({
  type: 'SHOW_TOOLTIP',
  data
})


export const showTooltip = data => dispatch => {

  if(data.e){
    data.e.persist();
    data.d = data.e.currentTarget.getBoundingClientRect();
    data.e.stopPropagation();
    data.e.preventDefault();
  }
  if(data.el){
    data.e = {
      target: data.el
    }
    data.d = data.el.getBoundingClientRect(); 
  }

  clearTimeout(tooltipTimeout);
  if(data.lag){
    tooltipTimeout = setTimeout(function(){

      dispatch(showTooltipNow(data));
    }, data.lag)
  } else {
    dispatch(showTooltipNow(data));
  }
}

export const hideTooltipNow = data => ({
  type: 'HIDE_TOOLTIP',
  data
})


export const hideTooltip = data => dispatch => {
  clearTimeout(tooltipTimeout);
  dispatch(hideTooltipNow());
}



// WEBPACK FOOTER //
// ./src/actions/actions.tooltip.js